import React from 'react';
import { withTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles';
import { Radio } from '@mui/material';

const StyleRadio = withStyles({
    root: {
      color: '#0F467A',
      '&$checked': {
        color: '#0F467A',
      },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const styles = theme => ({
    wallet_btn:{
        width:'73%',
        marginTop:'10px',
        alignSelf:'center',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
        border:'1px solid #e4e8ed',
        marginBottom:'10px',
        borderRadius:'8px',
        marginBottom:"10px",
        backgroundColor:'#fff',
        [theme.breakpoints.between('xs','md')]: {
            width:'100%'
		},
    },

    wallet_innDiv:{
        backgroundColor: 'transparent',
        borderBottom: 'none',
        marginBottom: -1,
        padding:'0px',
        minHeight: 56,
        height:'auto',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        cursor:'pointer',
        transition:'0.4s',
        backgroundColor:'transparent',
        padding:'0px 10px',
    },

    walletInDiv:{
        display:'flex',
        flexDirection:'column',
    },

    walletHead:{
        color: '#0F467A',
        fontSize:'13px',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'11px'
        },
    },

    panelTitle:{
        color:'#0F467A',
        fontWeight:'bold',
        fontFamily:"'Poppins', sans-serif",
        textTransform:'uppercase'
    },

    priceTitle:{
        color:'#0F467A',
        fontWeight:'bold',
        fontFamily:"'Poppins', sans-serif",
        textTransform:'uppercase',
        fontSize:'20px',
    },
})

class WalletButton extends React.Component {
    onChangeHandle = val => {
        this.props.onChange(val)
    }

    render() {
        const { walletValue, walletCurrency, paymentOption, classes, t, i18n } = this.props;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <div className={classes.wallet_btn} onClick={()=>this.onChangeHandle('wallet')}>
            <div className={classes.wallet_innDiv}>
                <div className={classes.walletInDiv}>
                    <span className={classes.panelTitle} style={{fontFamily}}>{t('booking.wallet')}</span>
                    <span className={classes.walletHead} style={{fontFamily}}>{t('booking.walletText')}</span>
                </div>
                <div className={classes.priceSection}>
                    <span className={classes.priceTitle}>{`${walletValue} ${walletCurrency}`}</span>
                    <StyleRadio
                        checked={paymentOption === 'wallet'}
                        onChange={()=>this.onChangeHandle('wallet')}
                        value="wallet"
                        name="radio-button-demo"
                        inputProps={{ 'aria-label': 'C' }}
                    />
                </div>
            </div>
        </div>
    )}
}

export default withStyles(styles)(withTranslation('common')(WalletButton));